/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React from 'react';
import {ProgressBar} from 'components/ProgressBar/ProgressBar';

const PollingView = () => (
  <ProgressBar
    waitTimeInSec={180}
    loadingTexts={['Waiting for your consent approval...', 'This may take a few moments...']}
    stopOnEndTime={false}
    heading="Verifying Consent"
    subheading=""
    footerTxt="Please complete the OTP verification in the opened tab"
    showShadow={false}
  />
);

export default PollingView;
